<template>
  <layout-simple>
    <v-container class="padded">
      <v-card flat>
        <v-card-title> Widerrufsrecht des Verbrauchers </v-card-title>
        <v-card-subtitle> Stand: 01.03.2024 </v-card-subtitle>

        <v-card-text>
          Diese Vereinbarung räumt dem Verbraucher ein Widerrufsrecht nach Maßgabe der nachfolgenden Widerrufsbelehrung
          ein. Verbraucher ist jede natürliche Person, die ein Rechtsgeschäft zu einem Zwecke abschließt, der weder
          ihrer gewerblichen noch ihrer selbständigen beruflichen Tätigkeit zugerechnet werden kann (§ 13 BGB).
        </v-card-text>

        <v-card-text>Widerrufsbelehrung</v-card-text>

        <v-card-text>
          Widerrufsrecht Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu. Die
          Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses. Um Ihr Widerrufsrecht auszuüben,
          müssen Sie uns ({{
            `${partner.companyName}, ${partner.address?.street}, ${partner.address?.zip} ${partner.address?.city}`
          }}, E-Mail: {{ partner.contact?.email }} mittels einer eindeutigen Erklärung (z. B. ein mit der Post
          versandter Brief oder E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Zur Wahrung
          der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der
          Widerrufsfrist absenden.
        </v-card-text>

        <v-card-text>
          Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben,
          einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie eine
          andere Art der Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt haben), unverzüglich
          und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf
          dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie
          bei der ursprünglichen Transaktion eingesetzt haben, es sei denn mit Ihnen wurde ausdrücklich etwas anderes
          vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.
        </v-card-text>

        <v-card-text>
          Haben Sie verlangt, dass die Dienstleistungen während der Widerrufsfrist beginnen sollen, so haben Sie uns
          einen angemessenen Betrag zu zahlen, der dem Anteil der bis zu dem Zeitpunkt, zu dem Sie uns von der Ausübung
          des Widerrufsrechts hinsichtlich dieses Vertrages unterrichten, bereits erbrachten Dienstleistungen im
          Vergleich zum Gesamtumfang der im Vertrag vorgesehenen Dienstleistungen entspricht.
        </v-card-text>

        <v-card-text>Muster-Widerrufsformular</v-card-text>

        <v-card-text>
          Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie es zurück.
        </v-card-text>
        <v-sheet :elevation="5" rounded class="ma-4">
          <v-card-text>
            {{ partner.companyName }}<br />
            {{ partner.address?.street }}<br />
            {{ partner.address?.zip }} {{ partner.address?.city }}<br />
            E-Mail: {{ partner.contact?.email }}<br /><br /><br />

            Hiermit widerrufe(n) ich/wir den von mir/uns abgeschlossenen Vertrag über die Erbringung der folgenden
            Dienstleistung: ____________________________________<br /><br />

            – Bestellt am: ______________<br />
            – Name des/der Verbraucher(s): ______________<br />
            – Anschrift des/der Verbraucher(s): ______________<br />
            – Unterschrift des/der Verbraucher(s): ______________<br />
            – Datum: ______________
          </v-card-text>
        </v-sheet>

        <v-card-text>
          Wir sind verpflichtet, dich als Verbraucher auf die Plattform zur Online-Streitbeilegung (OS-Plattform) der
          Europäischen Kommission hinzuweisen. Diese OS-Plattform ist über folgenden Link erreichbar:
          https://webgate.ec.europa.eu/odr. Wir nehmen an einem Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle allerdings nicht teil.
        </v-card-text>
      </v-card>
    </v-container>
  </layout-simple>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import LayoutSimple from "@/layouts/LayoutSimple.vue";
import { PartnerEntity } from "@/models/partnerEntity";
import { ReportModule } from "@/store/modules/report.store";

@Component({
  components: { LayoutSimple }
})
export default class Revocation extends Vue {
  get partner(): PartnerEntity {
    return ReportModule?.partner;
  }
}
</script>

<style scoped>
.contain {
  width: 100%;
  padding: 1em;
}
</style>
